import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=6df2ca3b"
import script from "./FooterLinks.vue?vue&type=script&lang=js"
export * from "./FooterLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports